import type { NewClientField } from "@/features/advice-portal/lib/new-client";

export interface NewClientFill {
  filled: NewClientField[];
  kept: NewClientField[];
  missing: NewClientField[];
  wrong: NewClientField[];
  createLabel: string;
}

export type NewClientFillReceiver = (prefill: Record<string, unknown>) => NewClientFill;

export function fillNewClientPage(prefill: Record<string, unknown>): NewClientFill | null {
  return receiver === null ? null : receiver(prefill);
}

export function receiveNewClientFills(receive: NewClientFillReceiver): () => void {
  receiver = receive;
  return () => {
    if (receiver === receive) receiver = null;
  };
}

let receiver: NewClientFillReceiver | null = null;
